import Auth from "@aws-amplify/auth";
import Lambda from "aws-sdk/clients/lambda";

import { Domain, getBartLambdaConfig } from "src/config/BartLambdaConfig"; // npm install aws-sdk

function invokeLambda(
  type: string,
  value: string,
  startDate: string,
  endDate: string,
  count: string,
  isTest: string,
  eventType: string,
  domain: Domain,
  callback: Function,
) {
  const lamdaConfig = getBartLambdaConfig(domain);
  return Auth.currentCredentials().then((credentials) => {
    const lambda = new Lambda({
      credentials: Auth.essentialCredentials(credentials),
      region: lamdaConfig.awsRegion,
    });
    let param = {
      FunctionName: lamdaConfig.transactionSearchLambdaARN,
      InvocationType: "RequestResponse",
      Payload: JSON.stringify({
        idType: type,
        value: value,
        startDate,
        endDate,
        count,
        isTest: isTest,
        eventType: eventType,
      }),
    };

    return lambda.invoke(param, function (err, data) {
      // callback function
      console.log("the value of data.Payload : ", data.Payload);
      if (
        err ||
        data.FunctionError ||
        data.StatusCode != 200 ||
        data.Payload == "null"
      ) {
        return callback("error"); //callback handle error
      } else if (
        JSON.parse(data.Payload as string)["fbtsV2Response"] == "" ||
        JSON.parse(data.Payload as string)["ftsResponse"] == ""
      ) {
        return callback("invalid");
      }
      const responseData = JSON.parse(data.Payload as string);
      console.log("the value of responseData : ", responseData);
      const fbtsV2Response = responseData["fbtsV2Response"];
      console.log("the value of fbtsV2Response : ", fbtsV2Response);
      const ftsResponse = responseData["ftsResponse"];
      console.log("the value of ftsResponse : ", ftsResponse);

      return callback({ fbtsV2Response, ftsResponse });
    });
  });
}
export default invokeLambda;
